import { useMemo } from 'react'
import cn from 'classnames/bind'

import { Summary } from 'app/dataTypes/reports/data/common/ordersByClasses'
import { SummaryWrap, SummaryItem } from 'app/common/templates-next/report-template/summary'

import styles from './summary.scss'

const cx = cn.bind(styles)

const translate = (key: keyof Summary): string => {
  if (key === 'withOrdersSubsidies') {
    return 'Питающихся за бюджетные средства'
  }
  if (key === 'withOrdersExpenses') {
    return 'Питающихся за родительские средства'
  }
  if (key === 'withOrders') {
    return 'Всего питающихся'
  }
  return undefined as never
}

const arrange: Array<keyof Summary> = ['withOrdersSubsidies', 'withOrdersExpenses', 'withOrders']

type Props = {
  summary?: Summary
  hasUnperformed?: boolean
  pending?: boolean
}

const SummaryComponent = ({ summary, hasUnperformed = false, pending }: Props) => {
  const values = useMemo(() => {
    return arrange.map((key) => ({
      key,
      title: translate(key),
      value: summary ? String(summary[key]) : '',
    }))
  }, [summary])

  return (
    <SummaryWrap className={cx({ wrapHasUnperformed: hasUnperformed })}>
      {values.map(({ key, title, value }) => (
        <SummaryItem key={key} title={title} value={value} pending={pending || !summary} />
      ))}
    </SummaryWrap>
  )
}

export default SummaryComponent
